( function () {
	'use strict';

	document.addEventListener( 'DOMContentLoaded', () => {
		document.querySelectorAll( '.aivb-docs-viewer' ).forEach( initViewer );
	} );

	function initViewer( viewer ) {
		const id          = viewer.id;
		const restDocs    = viewer.dataset.restDocs;
		const restSingle  = viewer.dataset.restSingle;
		const restFb      = viewer.dataset.restFb;
		const nonce       = viewer.dataset.nonce;
		const showToc     = viewer.dataset.showToc  === 'true';
		const showFb      = viewer.dataset.showFb   === 'true';
		const showRt      = viewer.dataset.showRt   === 'true';
		const showNav     = viewer.dataset.showNav  === 'true';
		const tree        = JSON.parse( viewer.dataset.tree || '[]' );

		// Panels
		const welcome     = document.getElementById( id + '-welcome' );
		const loadingEl   = document.getElementById( id + '-loading' );
		const searchRes   = document.getElementById( id + '-search-results' );
		const article     = document.getElementById( id + '-article' );
		const titleEl     = document.getElementById( id + '-title' );
		const metaEl      = document.getElementById( id + '-meta' );
		const bodyEl      = document.getElementById( id + '-body' );
		const breadEl     = document.getElementById( id + '-breadcrumb' );
		const tocEl       = document.getElementById( id + '-toc' );
		const tocListEl   = document.getElementById( id + '-toc-list' );
		const fbEl        = document.getElementById( id + '-feedback' );
		const fbYes       = document.getElementById( id + '-fb-yes' );
		const fbNo        = document.getElementById( id + '-fb-no' );
		const fbThanks    = fbEl ? fbEl.querySelector( '.aivb-dv__feedback-thanks' ) : null;
		const navEl       = document.getElementById( id + '-nav' );
		const prevBtn     = document.getElementById( id + '-prev' );
		const nextBtn     = document.getElementById( id + '-next' );
		const searchInput = viewer.querySelector( '.aivb-dv__search' );
		const treeEl      = document.getElementById( id + '-tree' );

		// Welcome category buttons
		viewer.querySelectorAll( '.aivb-dv__welcome-cat-btn' ).forEach( btn => {
			btn.addEventListener( 'click', () => {
				const catId = parseInt( btn.dataset.catId );
				openCategory( catId );
				// Load first doc of category
				const cat = tree.find( c => c.id === catId );
				if ( cat && cat.docs.length ) loadDoc( cat.docs[0].id );
			} );
		} );

		let currentDocId  = 0;
		let currentCatId  = 0;
		let debTimer      = null;
		let votedDocs     = new Set( JSON.parse( localStorage.getItem( 'aivb_voted' ) || '[]' ) );

		buildTree();

		// Auto-open category from URL parameter
		const urlParams = new URLSearchParams( window.location.search );
		const queryCatId = parseInt( urlParams.get( 'doc_cat' ), 10 );
		if ( queryCatId ) {
			openCategory( queryCatId );
			const cat = tree.find( c => c.id === queryCatId );
			if ( cat && cat.docs.length ) {
				loadDoc( cat.docs[0].id );
				setTimeout( () => {
					viewer.scrollIntoView( { behavior: 'smooth', block: 'start' } );
				}, 100 );
			}
		}

		function buildTree() {
			if ( ! treeEl ) return;
			// Category toggles already rendered by PHP; just wire up JS events
			treeEl.querySelectorAll( '.aivb-dv__cat-toggle' ).forEach( btn => {
				btn.addEventListener( 'click', () => {
					const cat    = btn.closest( '.aivb-dv__cat' );
					const list   = cat.querySelector( '.aivb-dv__doc-list' );
					const caret  = btn.querySelector( '.aivb-dv__cat-caret' );
					const isOpen = ! list.hidden;

					list.hidden = isOpen;
					btn.setAttribute( 'aria-expanded', String( !isOpen ) );
					caret.textContent = isOpen ? '›' : '∨';
					cat.classList.toggle( 'aivb-dv__cat--open', !isOpen );
				} );
			} );

			// Doc buttons
			treeEl.querySelectorAll( '.aivb-dv__doc-btn' ).forEach( btn => {
				btn.addEventListener( 'click', () => loadDoc( parseInt( btn.dataset.docId ) ) );
			} );
		}

		function openCategory( catId ) {
			const catEl = treeEl ? treeEl.querySelector( `.aivb-dv__cat[data-cat-id="${ catId }"]` ) : null;
			if ( ! catEl ) return;
			const list  = catEl.querySelector( '.aivb-dv__doc-list' );
			const caret = catEl.querySelector( '.aivb-dv__cat-caret' );
			const btn   = catEl.querySelector( '.aivb-dv__cat-toggle' );
			if ( list && list.hidden ) {
				list.hidden = false;
				btn && btn.setAttribute( 'aria-expanded', 'true' );
				if ( caret ) caret.textContent = '∨';
				catEl.classList.add( 'aivb-dv__cat--open' );
			}
		}

		function setActiveDoc( docId ) {
			treeEl && treeEl.querySelectorAll( '.aivb-dv__doc-btn' ).forEach( b => {
				b.classList.toggle( 'aivb-dv__doc-btn--active', parseInt( b.dataset.docId ) === docId );
			} );
		}

		// ── Search ────────────────────────────────────────────────────────
		searchInput && searchInput.addEventListener( 'input', () => {
			clearTimeout( debTimer );
			const q = searchInput.value.trim();
			if ( q.length < 2 ) {
				showPanel( 'welcome' );
				return;
			}
			debTimer = setTimeout( () => doSearch( q ), 300 );
		} );

		async function doSearch( query ) {
			showPanel( 'loading' );
			try {
				const url = new URL( restDocs );
				url.searchParams.set( 'search', query );
				url.searchParams.set( 'per_page', 20 );
				const res  = await apiFetch( url.toString() );
				const docs = await res.json();
				renderSearchResults( docs, query );
			} catch(e) {
				showPanel( 'welcome' );
			}
		}

		function renderSearchResults( docs, query ) {
			showPanel( 'search' );
			if ( ! docs.length ) {
				searchRes.innerHTML = `<div class="aivb-dv__search-empty">
					<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
					<p>No results for <strong>${ esc(query) }</strong></p>
				</div>`;
				return;
			}
			searchRes.innerHTML = `
				<div class="aivb-dv__search-header">
					<strong>${ docs.length } result${ docs.length !== 1 ? 's' : '' }</strong> for "${ esc(query) }"
				</div>
				${ docs.map( d => `
					<button class="aivb-dv__search-item" data-doc-id="${ d.id }">
						<div class="aivb-dv__search-item__cat">${ esc( d.category || '' ) }</div>
						<div class="aivb-dv__search-item__title">${ highlight( esc(d.title), query ) }</div>
						${ d.excerpt ? `<div class="aivb-dv__search-item__excerpt">${ esc(d.excerpt) }</div>` : '' }
					</button>
				`).join('') }`;

			searchRes.querySelectorAll( '.aivb-dv__search-item' ).forEach( btn => {
				btn.addEventListener( 'click', () => {
					searchInput.value = '';
					loadDoc( parseInt( btn.dataset.docId ) );
				} );
			} );
		}

		// ── Load doc ──────────────────────────────────────────────────────
		async function loadDoc( docId ) {
			showPanel( 'loading' );
			currentDocId = docId;
			setActiveDoc( docId );

			try {
				const res  = await apiFetch( restSingle + '/' + docId );
				const data = await res.json();
				renderDoc( data );
			} catch(e) {
				showPanel( 'welcome' );
			}
		}

		function renderDoc( data ) {
			// Breadcrumb
			if ( breadEl ) {
				breadEl.innerHTML = data.category
					? `<span class="aivb-dv__bc-cat">${ esc(data.category || '') }</span><span class="aivb-dv__bc-sep">›</span>`
					: '';
			}

			// Title
			if ( titleEl ) titleEl.textContent = data.title;

			// Meta
			if ( metaEl ) {
				let meta = '';
				if ( showRt && data.reading_time ) meta += `<span class="aivb-dv__meta-item">⏱ ${ esc(data.reading_time) }</span>`;
				if ( data.modified ) meta += `<span class="aivb-dv__meta-item">🗓 Updated ${ esc(data.modified) }</span>`;
				metaEl.innerHTML = meta;
			}

			// Body
			if ( bodyEl ) {
				bodyEl.innerHTML = data.content || '';
				// Inject anchor IDs into headings for TOC scrolling
				bodyEl.querySelectorAll( 'h2, h3' ).forEach( h => {
					if ( ! h.id ) h.id = slugify( h.textContent );
				} );
			}

			// TOC
			if ( showToc && tocEl && tocListEl ) {
				const items = data.toc || [];
				if ( items.length > 1 ) {
					tocListEl.innerHTML = items.map( item => `
						<li class="aivb-dv__toc-item aivb-dv__toc-item--h${ item.level }">
							<a href="#${ esc(item.slug) }" class="aivb-dv__toc-link" data-slug="${ esc(item.slug) }">${ esc(item.text) }</a>
						</li>
					`).join('');

					tocListEl.querySelectorAll( '.aivb-dv__toc-link' ).forEach( a => {
						a.addEventListener( 'click', e => {
							e.preventDefault();
							const target = bodyEl ? bodyEl.querySelector( '#' + CSS.escape( a.dataset.slug ) ) : null;
							if ( target ) {
								target.scrollIntoView( { behavior: 'smooth', block: 'start' } );
								// Highlight active
								tocListEl.querySelectorAll('.aivb-dv__toc-link').forEach( l => l.classList.remove('aivb-dv__toc-link--active') );
								a.classList.add( 'aivb-dv__toc-link--active' );
							}
						} );
					} );

					tocEl.style.display = 'block';
				} else {
					tocEl.style.display = 'none';
				}
			}

			// Feedback
			if ( showFb && fbEl ) {
				if ( fbYes ) fbYes.textContent = data.feedback_yes || 0;
				if ( fbNo  ) fbNo.textContent  = data.feedback_no  || 0;
				if ( fbThanks ) fbThanks.style.display = 'none';

				const voted = votedDocs.has( data.id );
				fbEl.querySelectorAll( '.aivb-dv__fb-btn' ).forEach( btn => {
					btn.disabled = voted;
					btn.classList.toggle( 'aivb-dv__fb-btn--voted', voted );
				} );
			}

			// Prev/Next nav
			if ( showNav && navEl ) {
				prevBtn.querySelector( 'span' ).textContent = data.prev ? data.prev.title : '';
				nextBtn.querySelector( 'span' ).textContent = data.next ? data.next.title : '';
				prevBtn.style.display = data.prev ? 'flex' : 'none';
				nextBtn.style.display = data.next ? 'flex' : 'none';

				if ( data.prev ) {
					prevBtn.onclick = () => loadDoc( data.prev.id );
				}
				if ( data.next ) {
					nextBtn.onclick = () => loadDoc( data.next.id );
				}

				navEl.style.display = ( data.prev || data.next ) ? 'flex' : 'none';
			}

			// Open category in sidebar
			const cat = tree.find( c => c.docs.some( d => d.id === data.id ) );
			if ( cat ) openCategory( cat.id );

			showPanel( 'article' );
		}

		// ── Feedback votes ────────────────────────────────────────────────
		fbEl && fbEl.querySelectorAll( '.aivb-dv__fb-btn' ).forEach( btn => {
			btn.addEventListener( 'click', async () => {
				if ( btn.disabled ) return;
				const vote = btn.dataset.vote;

				fbEl.querySelectorAll( '.aivb-dv__fb-btn' ).forEach( b => { b.disabled = true; } );

				try {
					const res  = await apiFetch( restFb + '/' + currentDocId + '/feedback', 'POST', { vote } );
					const data = await res.json();
					if ( fbYes ) fbYes.textContent = data.feedback_yes;
					if ( fbNo  ) fbNo.textContent  = data.feedback_no;
					if ( fbThanks ) fbThanks.style.display = 'block';
					btn.classList.add( 'aivb-dv__fb-btn--voted' );

					// Persist
					votedDocs.add( currentDocId );
					localStorage.setItem( 'aivb_voted', JSON.stringify( [...votedDocs] ) );
				} catch(e) {}
			} );
		} );

		// ── Scroll spy for TOC ────────────────────────────────────────────
		const contentPanel = viewer.querySelector( '.aivb-dv__content' );
		contentPanel && contentPanel.addEventListener( 'scroll', () => {
			if ( ! showToc || ! bodyEl ) return;
			const headings = bodyEl.querySelectorAll( 'h2, h3' );
			let active = null;
			const scrollTop = contentPanel.scrollTop + 80;
			headings.forEach( h => { if ( h.offsetTop <= scrollTop ) active = h; } );
			if ( active && tocListEl ) {
				tocListEl.querySelectorAll( '.aivb-dv__toc-link' ).forEach( a => {
					a.classList.toggle( 'aivb-dv__toc-link--active', a.dataset.slug === active.id );
				} );
			}
		} );

		// ── Panel management ──────────────────────────────────────────────
		function showPanel( which ) {
			welcome   && ( welcome.style.display   = which === 'welcome' ? 'flex' : 'none' );
			loadingEl && ( loadingEl.style.display = which === 'loading' ? 'flex' : 'none' );
			searchRes && ( searchRes.style.display = which === 'search'  ? 'block': 'none' );
			article   && ( article.style.display   = which === 'article' ? 'block': 'none' );
		}

		// ── Helpers ────────────────────────────────────────────────────────
		function apiFetch( url, method = 'GET', body = null ) {
			const opts = { method, headers: { 'X-WP-Nonce': nonce } };
			if ( body ) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify( body ); }
			return fetch( url, opts );
		}

		function esc( s ) { const d = document.createElement('div'); d.textContent = String(s||''); return d.innerHTML; }

		function highlight( text, q ) {
			return text.replace( new RegExp( '(' + q.replace(/[.*+?^${}()|[\]\\]/g,'\\$&') + ')', 'gi' ), '<mark>$1</mark>' );
		}

		function slugify( s ) {
			return s.toLowerCase().replace( /[^\w\s-]/g,'' ).trim().replace( /[\s_-]+/g,'-' );
		}
	}
} )();
